export default {"src":"/_next/static/media/hdfc-logo.4649cd69.svg","height":54,"width":81,"blurWidth":0,"blurHeight":0};